function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m489.536 219.221c-1.813-3.605-5.504-5.888-9.536-5.888h-96v21.333h113.259z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m340.203 69.888c-1.813-3.605-5.504-5.888-9.536-5.888h-149.334c-4.032 0-7.723 2.283-9.536 5.888l-7.723 15.445h183.851z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m511.509 264.213c-.171-.683-.256-1.365-.533-1.984-1.685-3.648-5.355-6.229-9.643-6.229h-138.666v-138.667c0-.875-.299-1.643-.491-2.453-.171-.683-.256-1.365-.533-1.984-1.685-3.648-5.355-6.229-9.643-6.229h-192c-4.288 0-7.936 2.581-9.643 6.229-.277.619-.384 1.301-.533 1.984-.192.811-.491 1.579-.491 2.453v117.333h-138.666c-4.288 0-7.936 2.581-9.643 6.229-.277.619-.384 1.301-.533 1.984-.192.812-.491 1.58-.491 2.454v192c0 5.867 4.779 10.667 10.667 10.667h490.667c5.888 0 10.667-4.8 10.667-10.667v-170.666c-.001-.875-.3-1.643-.492-2.454zm-404.842 98.432v.021c5.888 0 10.667 4.779 10.667 10.667s-4.779 10.667-10.667 10.667h-42.667c-4.309 0-8.213-2.603-9.856-6.592-1.664-3.989-.747-8.576 2.304-11.627l27.584-27.584c7.701-7.722 11.968-17.984 11.968-28.885 0-5.867-4.779-10.667-10.667-10.667s-10.667 4.8-10.667 10.667c0 5.888-4.779 10.667-10.667 10.667s-10.667-4.779-10.667-10.667c0-17.643 14.357-32 32-32s32 14.357 32 32c0 16.576-6.464 32.213-18.219 43.968l-9.365 9.365zm170.688-74.645h-.021c0 5.888-4.779 10.667-10.667 10.667s-10.667-4.779-10.667-10.667v-80.917l-3.115 3.115c-4.16 4.16-10.923 4.16-15.083 0s-4.16-10.923 0-15.083l21.333-21.333c3.051-3.072 7.637-3.968 11.627-2.304 3.989 1.643 6.592 5.547 6.592 9.856v106.666zm181.312 85.333c0 17.643-14.357 32-32 32s-32-14.357-32-32c0-5.888 4.779-10.667 10.667-10.667s10.667 4.779 10.667 10.667c-.001 5.867 4.778 10.667 10.666 10.667s10.667-4.8 10.667-10.667-4.779-10.667-10.667-10.667-10.667-4.778-10.667-10.666 4.779-10.667 10.667-10.667 10.667-4.8 10.667-10.667-4.779-10.667-10.667-10.667-10.667 4.801-10.667 10.668c0 5.888-4.779 10.667-10.667 10.667s-10.667-4.779-10.667-10.667c0-17.643 14.357-32 32-32s32 14.357 32 32c0 8.192-3.093 15.659-8.171 21.333 5.078 5.675 8.172 13.141 8.172 21.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m128 192h-96c-4.032 0-7.723 2.283-9.536 5.888l-7.723 15.445h113.259z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgPodium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffd764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.ae9f143b.svg";
export { ForwardRef as ReactComponent };